import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';

const QRCode = ({ value, size = 128 }) => {
  return <QRCodeCanvas value={value} size={size} />;
};

export default QRCode;
